export default __webpack_public_path__ + "static/media/settings.0279bc24.svg";